import { render } from "./SocialsItem.vue?vue&type=template&id=2b6bcdf8&scoped=true"
import script from "./SocialsItem.vue?vue&type=script&lang=js"
export * from "./SocialsItem.vue?vue&type=script&lang=js"

import "./SocialsItem.vue?vue&type=style&index=0&id=2b6bcdf8&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b6bcdf8"]])

export default __exports__